module.exports = __webpack_public_path__ + "img/mirror28.354f4ce5.jpg";